module.exports = __webpack_public_path__ + "static/media/S1N13-5.be2b36a5.svg";